import { Grid } from '@mantine/core';
import { ReactNode } from 'react';

const XCol4 = ({ children }: { children?: ReactNode }) => {
  return (
    <Grid.Col xs={12} sm={4}>
      {children}
    </Grid.Col>
  );
};

export default XCol4;
